<template>
<section>


  <!-- Save button -->
  <div class="StickySaveButton">
		<button class="pillButton" @click="save()" :class="{ 'disabled' : !changesMade }" :disabled="!changesMade">
			Save Changes
		</button>
	</div>

  <div class="absolute" style="top: 0.5em; right: 14em;"><strong><a target="new" :href="`${baseURL}/edittemplate/${newItem.urlSlug}`">Preview</a></strong></div>

  <!-- Top Matter -->
  <div class="flex-row flex-grow flex-gap-1 ma-1">
    <label class='flex-column' style="width: 400px;">
      <span>URL slug:</span>
      <input type="text" v-model="newItem.urlSlug" :disabled="!isNew" />
    </label>

    <label class='flex-column' style="width: 400px;">
      <span>Admin Label (Internal Name):</span>
      <input type="text" v-model="newItem.adminLabel" />
    </label>
  </div>

  <!-- <label class='flex-column ma-1' style="width: 400px;">
    <div class="mt-05">Default Coupon Code:</div>
    <input type="text" v-model="newItem.defaultCoupon" placeholder="inherit from Affiliate" />
  </label> -->


  <!-- Header Settings -->
  <fieldset class="HeaderSettings ma-1 pa-1">
    <legend>Header Settings</legend>

    <div>
      <div class="flex-row flex-align-center flex-justify-between">
        <div class="flex-row flex-align-center flex-gap-05">
          <span style="font-weight: bold;">Masthead Links</span>
          <span style="color: #888; font-size: 0.8em;">empty = use the client's default links</span>
        </div>
        <button @click.stop="newItem.addMastheadLink()"><span class="icon-plus" /> Add Link</button>
      </div>

      <div v-for="(link, index) in (newItem.mastheadLinks || [])" :key="index" class="mastheadLink">
        <div class="leftNav">
          <div @click.prevent="newItem.swapMastheadLinks(index, index-1)" class="icon-arrow-up" />&nbsp;
          <div @click.prevent="newItem.swapMastheadLinks(index, index+1)" class="icon-arrow-down" />
        </div>
        <div class="flex-row flex-align-center flex-gap-05 w-100" style="padding-right: 1.5em;">
          <input type="text" v-model="link.label" placeholder="Label (e.g. Program Overview)" class="flex-grow" />
          <input type="text" v-model="link.href" placeholder="Href (e.g. #overview)" class="flex-grow" />
          <input type="text" v-model.trim="link.target" placeholder="Target (e.g. _blank)" @input="normalizeTarget(link)" style="width: 10em;" />
        </div>
        <span class="icon-cross" style="position: absolute; right: 0.5em; top: 0.5em;" @click.stop="newItem.removeMastheadLink(index)" />
      </div>

      <label class='mt-1 border-top pt-1 flex-row flex-align-center flex-gap-05'>
        <span>Header Max Width:</span>
        <input type="text" v-model.trim="headerMaxWidth" placeholder="1080px" style="width: 8em;" />
      </label>

    </div>
  </fieldset>


  <!-- Tabs -->
	<section v-if="newItem.affiliates !== null" class="Tab mt-2">
		<button @click="mode = 'landingPageSections'" :class="{ active: mode === 'landingPageSections' }">Landing Page Sections</button>
		<button @click="mode = 'affiliateList'" :class="{ active: mode === 'affiliateList' }">Used by {{ newItem.affiliates.length }} Affiliate{{ newItem.affiliates.length != 1 ? 's' : '' }}</button>
	</section>


  <!-- Landing Page Sections -->
  <section v-if="mode === 'landingPageSections'" id="sectionsWrapper" class="relative" @click.stop="selectedSectionIndex = null">
    <!-- <h2 class="mt-3">Sections:</h2> -->

    <div class="flex-row flex-align-center flex-justify-center flex-gap-05 pt-2">
      <button @click.stop="newItem.addHTMLSection( 0 )"><span class="icon-plus" /> HTML</button>
      <button @click.stop="newItem.addPrimaryQuoteSection( 0 )"><span class="icon-plus" /> Primary Quote</button>
      <button @click.stop="newItem.addImageSection( 0 )"><span class="icon-plus" /> Image</button>
      <button @click.stop="newItem.addSliderSection( 0 )"><span class="icon-plus" /> Slider</button>
      <button @click.stop="newItem.addStorefrontSection( 0 )"><span class="icon-plus" /> Storefront</button>
      <button @click.stop="newItem.addChatSection( 0 )"><span class="icon-plus" /> Chat</button>
      <button @click.stop="newItem.addBuiltInSection( 0 )"><span class="icon-plus" /> Built-In</button>
    </div>

    <div v-for="(section, index) in newItem.sections" :key="section.vueID">
      <div class="section" :class="{ 'selected' : selectedSectionIndex === index }" @click.stop="selectedSectionIndex = index">
        <div class="leftNav">
          <div @click.prevent="newItem.swapSections(index, index-1)" class="icon-arrow-up" />&nbsp;
          <div @click.prevent="newItem.swapSections(index, index+1)" class="icon-arrow-down" />
        </div>&nbsp;
        <div class="pa-05 w-100">

          <!-- Section names are the key affiliate overrides are matched on - flag anything that breaks them -->
          <div v-if="duplicateNames.has( section.name || '' )" class="nameAlert error">
            <span class="icon-warning" />
            <span v-if="section.name">Another section is also called &ldquo;{{ section.name }}&rdquo;. Section names must be unique - duplicates break affiliate overrides on every page using this template.</span>
            <span v-else>More than one section has a blank name. Section names must be unique - duplicates break affiliate overrides on every page using this template.</span>
          </div>
          <div v-else-if="!section.name" class="nameAlert warn">
            <span class="icon-warning" /> This section has no name. Give it one - the name is how affiliate overrides are matched to it.
          </div>
          <div v-else-if="renamedFrom( section )" class="nameAlert warn">
            <span class="icon-warning" />
            Renamed from &ldquo;{{ renamedFrom( section ) }}&rdquo;. Any affiliate that has customised this section did so under the old name - saving will orphan those customisations{{ affiliateCountText }}, and the section will fall back to the template's content on their pages.
          </div>

          <LandingPageHTMLSection v-if="!section.type || section.type == 'html'" :section="section" @click.stop="selectedSectionIndex = index" />
          <LandingPagePrimaryQuoteSection v-else-if="section.type == 'primaryQuote'" :section="section" @click.stop="selectedSectionIndex = index" />
          <LandingPageImageSection v-else-if="section.type == 'image'" :section="section" />
          <LandingPageSliderSection v-else-if="section.type == 'slider'" :section="section" />
          <LandingPageStorefrontSection v-else-if="section.type == 'storefront'" :section="section" />
          <LandingPageChatSection v-else-if="section.type == 'chat'" :section="section" />
          <LandingPageBuiltInSection v-else-if="section.type == 'builtin'" :section="section" :landingPage="newItem" :isNewSection="isNewSection( section )" />
        </div>
        <span class="icon-cross" style="position: absolute; right: 0.5em; top: 0.5em;" @click.stop="deleteSection(index)" />

      </div>
      <div v-if="selectedSectionIndex == index" class="flex-row flex-align-center flex-justify-center flex-gap-05 pa-05">
        <button @click.stop="newItem.addHTMLSection( ++selectedSectionIndex )"><span class="icon-plus" /> HTML</button>
        <button @click.stop="newItem.addPrimaryQuoteSection( ++selectedSectionIndex )"><span class="icon-plus" /> Primary Quote</button>
        <button @click.stop="newItem.addImageSection( ++selectedSectionIndex )"><span class="icon-plus" /> Image</button>
        <button @click.stop="newItem.addSliderSection( ++selectedSectionIndex )"><span class="icon-plus" /> Slider</button>
        <button @click.stop="newItem.addStorefrontSection( ++selectedSectionIndex )"><span class="icon-plus" /> Storefront</button>
        <button @click.stop="newItem.addChatSection( ++selectedSectionIndex )"><span class="icon-plus" /> Chat</button>
        <button @click.stop="newItem.addBuiltInSection( ++selectedSectionIndex )"><span class="icon-plus" /> Built-In</button>
      </div>

    </div>

  </section>


  <!-- List of affiliates using this page -->
  <section v-if="mode === 'affiliateList'">
    <ObjectTable
      v-if="newItem.affiliates !== null"
      :Source="newItem.affiliates"
      :Columns='columns'
    />
  </section>


</section>
</template>

<script>
import SalesManagementAPI from '@/api/SalesManagementAPI.js'
import LandingPage from './LandingPage.js'
import { powerprep_base_url } from '@/Config.js'

import LandingPageHTMLSection from './LandingPageSections/LandingPageHTMLSection.vue'
import LandingPagePrimaryQuoteSection from './LandingPageSections/LandingPagePrimaryQuoteSection.vue'
import LandingPageImageSection from './LandingPageSections/LandingPageImageSection.vue'
import LandingPageSliderSection from './LandingPageSections/LandingPageSliderSection.vue'
import LandingPageStorefrontSection from './LandingPageSections/LandingPageStorefrontSection.vue'
import LandingPageChatSection from './LandingPageSections/LandingPageChatSection.vue'
import LandingPageBuiltInSection from './LandingPageSections/LandingPageBuiltInSection.vue'
import ObjectTable from '@/components/utilities/ObjectTable.vue'

export default {
  name: "LandingPageDetails",

  components: {
    LandingPageHTMLSection,
    LandingPagePrimaryQuoteSection,
    LandingPageImageSection,
    LandingPageSliderSection,
    LandingPageStorefrontSection,
    LandingPageChatSection,
    LandingPageBuiltInSection,
    ObjectTable,
  },

  props: {
    itemIn: Object,
    isNew: Boolean,
  },

  data() {
    return {
      newItem: Object,
      mode: 'landingPageSections',
      selectedSectionIndex: null,

      // vueID -> name, snapshotted at load.  Sections added since aren't in here, which is how
      // we tell "renaming something affiliates may already reference" from "naming a new block".
      originalSectionNames: {},

      columns: [
        {
          displayName: 'Affiliate ID',
          propertyName: 'id',
          sortable: false
        },
        {
          displayName: 'Affiliate Name',
          propertyName: 'name',
          sortable: false
        },
        {
          displayName: 'URL Slug',
          propertyName: 'urlSlug',
          sortable: false
        },
      ],
    }
  },

  async created() {
    this.newItem = this.itemIn.clone();

    // Snapshot from newItem, not itemIn - clone() regenerates every section's vueID
    for( const section of this.newItem.sections ) this.originalSectionNames[ section.vueID ] = section.name || '';
  },

  computed: {
		baseURL() { return powerprep_base_url },
    headerMaxWidth: {
      get() { return this.newItem.headerMaxWidth || '' },
      set(value) { this.newItem.headerMaxWidth = value ? value : null },
    },
    changesMade() {
      if(this.newItem && !this.itemIn.isSame(this.newItem)) return true;
      return false;
    },

    duplicateNames() {
      if( !this.newItem || !this.newItem.sections ) return new Set();
      return this.newItem.duplicateSectionNames();
    },

    affiliateCountText() {
      if( !this.newItem || !this.newItem.affiliates || !this.newItem.affiliates.length ) return '';
      const count = this.newItem.affiliates.length;
      return ` on ${count} affiliate page${ count != 1 ? 's' : '' }`;
    },
  },


  methods: {

    /** True for sections added during this editing session (i.e. never saved, so no affiliate can reference them) */
    isNewSection( section ) {
      return !( section.vueID in this.originalSectionNames );
    },

    /** The name a previously-saved section was loaded with, if the admin has since changed it; else null */
    renamedFrom( section ) {
      if( this.isNewSection( section ) ) return null;

      const originalName = this.originalSectionNames[ section.vueID ];
      if( originalName === ( section.name || '' ) ) return null;
      return originalName || '(blank)';
    },


    deleteSection(index) {
      const choice = confirm("Really delete this section?");
      if(choice) this.newItem.deleteSection(index);
      this.selectedSectionIndex = null
    },

    // Store an empty target as null so it's omitted rather than sent as ''
    normalizeTarget(link) {
      if(!link.target) link.target = null;
    },



    async save() {

      // Duplicate names silently break affiliate overrides, so refuse to persist them.
      // A single blank name is only warned about - legacy templates have them and are still valid.
      const duplicates = this.duplicateNames;
      if( duplicates.size ) {
        const names = [ ...duplicates ].map( name => name ? `"${name}"` : '(blank)' ).join( ', ' );
        alert( `Cannot save: more than one section is named ${names}.\n\nSection names are how an affiliate's customisations are matched to a template section, so they must be unique within this page. Please rename the duplicates and try again.` );
        return;
      }

      const renamed = this.newItem.sections.filter( section => this.renamedFrom( section ) );
      if( renamed.length ) {
        const names = renamed.map( section => `  "${ this.renamedFrom( section ) }"  ->  "${ section.name }"` ).join( '\n' );
        const affiliateText = this.affiliateCountText || ' on any affiliate page';
        const choice = confirm( `You have renamed ${ renamed.length } section${ renamed.length != 1 ? 's' : '' }:\n\n${names}\n\nAffiliates customised these sections under their old names. Saving will orphan those customisations${affiliateText} - the sections will fall back to this template's content there.\n\nSave anyway?` );
        if( !choice ) return;
      }

      if(this.isNew) {
        await SalesManagementAPI.createLandingPage(this.newItem.export());
        const obj = await SalesManagementAPI.getLandingPage(this.newItem.urlSlug);
        const newItem = LandingPage.import(obj);
        this.$emit('itemAdded', newItem);
      } else {
        await SalesManagementAPI.editLandingPage(this.newItem.export());
        this.$emit('itemEdited', this.newItem.clone());
      }

      // The saved names are the new baseline - stop warning about renames we've now persisted
      this.originalSectionNames = {};
      for( const section of this.newItem.sections ) this.originalSectionNames[ section.vueID ] = section.name || '';
    },


  }



}
</script>

<style scoped>
input, textarea { padding: 0.5em !important; }

.nameAlert {
  display: flex;
  align-items: flex-start;
  gap: 0.5em;
  margin-bottom: 0.5em;
  padding: 0.5em 0.75em;
  border-radius: 4px;
  font-size: 0.85em;
  line-height: 1.4;
}
.nameAlert .icon-warning { flex: 0 0 auto; margin-top: 0.15em; }

.nameAlert.error {
  background-color: #fdecea;
  border: 1px solid #d93025;
  color: #a5170f;
}
.nameAlert.warn {
  background-color: #fff8e1;
  border: 1px solid #e0a800;
  color: #7a5c00;
}

.HeaderSettings {
  border: 1px solid #888;
  border-radius: 5px;
  background-color: var(--pp10-gray-95);
}
.HeaderSettings > legend {
  padding: 0 0.5em;
  font-weight: bold;
}
.mastheadLink {
  position: relative;
  display: flex;
  align-items: center;
  border: 1px solid gray;
  border-radius: 5px;
  background-color: white;
  margin: 0.5em 0;
  padding: 0.5em;
}
.mastheadLink .leftNav {
  border-right: 1px solid lightgray;
  padding: 0 0.5em;
  margin-right: 0.5em;
}
.mastheadLink input { margin: 0.25em 0; }

#sectionsWrapper {
  background-color: var(--pp10-gray-95);
  padding-bottom: 3em;
}
.section {
  display: flex;
  border: 1px solid #888;
  border-radius: 5px;
  /* background: #f8f8f8; */
  box-shadow: 0 6px 12px -6px #888;
  /* padding: 0.5em 0.5em 0.5em 0; */
  margin: 3em 4em;
  position: relative;
  transition: all 0.5s;
  background-color: white;
}

.leftNav {
  border-right: 1px solid lightgray;
  padding: 1em 0.5em;
}

.section.selected {
  border-color: var(--pp10-purple) !important;
  border-width: 4px;
}

.section.selected .leftNav {
  background-color: var(--pp10-purple-95);
}
</style>
